import { useTranslation } from 'next-i18next';
import React from 'react';
import { MarginComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';

const MarginComponent = ({ uiComponent }: UiComponentElementInterface<MarginComponentInterface>) => {
  const { t } = useTranslation(['pagebuilder']);

  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      <EmptyComponent height={uiComponent?.margin} componentName={t('pagebuilder:margin')} />
    </>
  );
};

export default MarginComponent;
